export default __webpack_public_path__ + "static/media/section345_background.e67d1475.svg";